<template>
  <div class="signcheck">
    <h1>申请处方</h1>
    <div style="text-align:center; width:100%">
    <el-form ref="form" :model="form" :rules="rules"  >
      <el-form-item label="电话号码" prop="telno" style="position:relative; left:20%">
        <el-col :span="10">
          <el-input v-model="form.telno" maxlength="15" ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item style="position:relative; left:44%; width:100px">
        <el-button type="primary" @click="onSubmit('form')">申请处方</el-button>
      </el-form-item>
    </el-form>
    </div>
  </div>
</template>



<script>
import qs from "qs";
export default {
  name: "SignCheck",
  data() {
    return {
      signCheckApi: "http://121.196.220.228:30002/isRegistered",
      form: {
        telno: ""
      },
      rules: {
        telno: [
          { required: true, message: "请输入电话号码", trigger: "blur" },
          { min: 7, max: 15, message: "长度在 7 到 15 个字符", trigger: "blur" }
        ]
      }
    };
  },
  props: {
    msg: String
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        let _this = this;

        if (valid) {
          if (_this.form.telno.trim() == "") {
            alert("请正确填写手机号");
          } else {
            //pretend that login successfully.
            //let tempToken = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOjEsInJvbGUiOjIsImlhdCI6MTU3Nzc3NzM4OH0.A_GZqMoa15AATplSeuip6-ONHBzRNItHQK_SeR17ESW8DV5cnWWWYU14Ac-tzbvxTR0p7OAz6P2vBmXHYH96lRX5UpPH0rJqrjWoDG2g2z2t1MxbNWo--jmu0qhI_d70Q4P902YGcuRIP5kBEbMz8YxwWsInmTrHFuweRJ4jMUejNNjIfQ3tsa3M4JLUahM4hryK_eH2dbWrfnH4f5kL3ZvNcab7ciBo5q9m9gOQVhvw-UXv_l2z_Njd9rZDpQvb8H3QG9tAahA5qgRvekKSgBIt4vvEHFEmQrelZvMnNJCNc-mJjAdtbBg6zwLyIrRNjlaziaQ6dxjdzJiS6GPUFg';
            //sessionStorage.setItem("authToken", tempToken);
            //console.log(sessionStorage.getItem("authToken"));
            let datas = {
              phoneNumber: _this.form.telno + "",
              authToken: sessionStorage.getItem("authToken")
              };
            console.log(datas);
            _this.axios
              .post(_this.signCheckApi, qs.stringify(datas))
              .then(response => {
                let res = response.data;
                console.log(res);
                if (res.data.result == "success") {
                  if (res.data.registered == true) {
                    sessionStorage.setItem("userPhone", _this.form.telno);
                    _this.$router.replace("/SignUpdate");
                  } else {
                    sessionStorage.setItem("userPhone", _this.form.telno);
                    _this.$router.replace("/RecipeAdd1");
                  }
                } else if (res.data.result == "fail") {
                  if (res.data.err == "invalid phone number") {
                    alert("请输入正确的手机号码");
                  } else {
                    alert(res.data.err);
                  }
                }
              }).catch((e) => { alert(e+"，登录超时，请重新登录");});
          }
        } else {
          alert("提交出错");
          return false;
        }
      });
    }
  },
  mounted() {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.signcheck {
  text-align: center;
  padding-top: 100px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
